export enum ClassificationState {
	ERROR = 'error',
	NO_CLASSIFICATION = 'no_classification',
	FETCHED = 'fetched',
	UNDEFINED = 'undefined',
}
